/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tourh_SubInputs */

const en_wc_tourh_sub = /** @type {(inputs: Wc_Tourh_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official screenshots of WordCraft itself. Drag or scroll sideways to see each ribbon tab.`)
};

/**
* | output |
* | --- |
* | "Official screenshots of WordCraft itself. Drag or scroll sideways to see each ribbon tab." |
*
* @param {Wc_Tourh_SubInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tourh_sub = /** @type {((inputs?: Wc_Tourh_SubInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tourh_SubInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tourh_sub(inputs)
});
export { wc_tourh_sub as "wc.tourh.sub" }